<template>
  <div class="vx-row" style="margin-top: 10px">
    <div class="vx-col md:w-1/1 w-full" style="margin-bottom: 160px">
      <vx-card title="Form Tax Invoice">
        <div class="vx-row mb-6 ml-4 mr-4" style="z-index: 99999 !important">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Company</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <formInputs :components="this.formInput.inputs" />
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Operating Unit</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <formInputs
              :components="this.formOu.inputs"
              @handlerSearch="handlerSearchMS"
              @update-forminput="this.updateforminput"
            />
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Territory</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <formInputs :components="this.formTerritory.inputs" />
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Supplier</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <formInputs :components="this.formSupplier.inputs" />
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Invoice Date</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <formInputs v-if="render" :components="this.formPostingDate.inputs" />
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Search</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <vs-input v-model="table.search" class="w-full"/>
          </div>
        </div>
        <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-4/5 w-full text-center">
            <vs-button
              class="mr-4"
              @click="handleView()"
              color="primary"
              icon-pack="feather"
              >View
            </vs-button>
            <vs-button
              @click="handleExport()"
              :disabled="!this.itemRefs.some((dt) => dt.inputs[1].components.value)"
              color="danger"
              icon-pack="feather"
              type="border"
              >Export
            </vs-button>
          </div>
        </div>
        <vs-row class="mb-6 ml-4 mr-4" vs-w="12">
          <vs-col
            class="mb-3"
            vs-type="flex"
            vs-justify="left"
            vs-align="center"
            vs-w="12"
          >
            <span>Total Invoice : {{ this.itemRefs.length }}</span>
          </vs-col>
        </vs-row>
        <vs-divider class="mb-2"></vs-divider>
        <!-- <div class="vx-row mb-6 ml-4 mr-4">
          <div class="vx-col sm:w-5/5 w-full">
            <datatable
              :itemRefs="this.itemRefs"
              :tablep="this.table"
              :modelItemRefInput="this.tmpitemRef"
              @search-itemref ="handleSearch"
              @update-itemref="updateitemref"
              @change-length ="handleChangelength"
              @input-itemref="oninput"
              @click="handlerClick"
              @handleChangePage="handleChangePage"
            />
          </div>
        </div> -->
        <vs-tabs :color="colorx" v-model="tabs">
          <vs-tab @click="
            colorx = 'success';
          tabClick(0);
          " label="SN Export">
            <div class="con-tab-ejemplo">
              <datatable
                :itemRefs="this.itemRefs"
                :tablep="this.table"
                :modelItemRefInput="this.tmpitemRef"
                :hideSearch="true"
                @search-itemref ="handleSearch"
                @update-itemref="updateitemref"
                @change-length ="handleChangelength"
                @input-itemref="oninput"
                @click="handlerClick"
                @handleChangePage="handleChangePage"
              />
            </div>
          </vs-tab>
          <vs-tab @click="
            colorx = 'warning';
          tabClick(1);
          " label="Data Export">
            <div class="con-tab-ejemplo">
              <!-- <vs-row class="mb-6 ml-4 mr-4">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"> -->
                  <!-- Export -->
                  <export_table :hideSearch="true" type="tax-invoice-ap-invoice"/>
                <!-- </vs-col>
              </vs-row> -->

            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>
import datatable from "../datatable.vue";
import formInputs from "../form_inputs.vue";
import moment from "moment";
import export_table from "./export_table.vue"
export default {
  components: {
    datatable,
    formInputs,
    export_table
  },
  props: {
    taxNumberLength: Number,
  },
  data() {
    return {
      render: true,
      tabs: 0,
      colorx: "success",
      selected: {},
      responseData: {},
      users: [],
      type: 0,
      tempDataOu:[],
      table:{
        start:1,
        stripe:true,
        end : 0,
        page: 0,
        length: 10,
        model :{},
        search: "",
        order: "id",
        sst: true,
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        
      },
      data: {
        npwp: "",
      },
      formTaxEntity: {
        id: 1,
        inputs: {
          disabled: false,
          validate: "required",
          name: "taxt_entity",
          placeholder: "Type to search",
          type: "multiselect",
          value: {},
          option: [],
          multiple: false,
          allowempty: false,
          track_by: "ID",
          onSelectEvent: (selected) => {
            console.log(selected);
          },
        },
      },
      formOu: {
        id: 2,
        inputs: {
          disabled: false,
          validate: "required",
          name: "operating_unit",
          placeholder: "Type to search",
          type: "multiselect",
          value: {},
          option: [],
          multiple: false,
          allowempty: false,
          internal_search:false,
          clear_on_select:false,
          track_by: "ID",
          onSelectEvent: (selected) => {
            console.log(selected);
          },
        },
      },
      formTerritory: {
        id: 3,
        inputs: {
          disabled: false,
          validate: "required",
          name: "territory",
          placeholder: "Type to search",
          type: "multiselect",
          value: {},
          option: [],
          multiple: false,
          allowempty: false,
          track_by: "ID",
          onSelectEvent: (selected) => {
            console.log(selected);
          },
        },
      },
      formSupplier: {
        // id: 3,
        inputs: {
          disabled: false,
          validate: "required",
          name: "supplier",
          placeholder: "Type to search",
          type: "multiselect",
          value: [{ID: 0, text: "All"}],
          option: [],
          multiple: true,
          allowempty: false,
          track_by: "ID",
        },
      },
      formTaxInvoiceType: {
        id: 4,
        inputs: {
          disabled: false,
          validate: "required",
          name: "territory",
          placeholder: "Type to search",
          type: "multiselect",
          value: {},
          option: [],
          multiple: false,
          allowempty: false,
          track_by: "ID",
          onSelectEvent: (selected) => {
            console.log(selected);
          },
        },
      },
      formInput: {
        id: 5,
        inputs: {
          disabled: false,
          validate: "required",
          name: "tax_entity",
          placeholder: "Tax Entity",
          type: "input",
          value: "",
        },
      },
      formFromCode: {
        id: 3,
        inputs: {
          disabled: false,
          validate: "required",
          name: "from_code",
          placeholder: "Type to search",
          type: "multiselect",
          value: {},
          option: [],
          multiple: false,
          allowempty: false,
          track_by: "id",
          onSelectEvent: (selected) => {
            console.log(selected);
          },
        },
      },
      formToCode: {
        id: 3,
        inputs: {
          disabled: false,
          validate: "required",
          name: "to_code",
          placeholder: "Type to search",
          type: "multiselect",
          value: {},
          option: [],
          multiple: false,
          allowempty: false,
          track_by: "id",
          onSelectEvent: (selected) => {
            console.log(selected);
          },
        },
      },
      formPostingDate: {
        id: 9,
        inputs: this.formInputPostingDate(),
      },
      itemRefs: [],
      tmpitemRef: {
        id: 2,
        action: false,
        inputs: this.getInputsHead(),
      },
      DataOperatingUnit: [],
      DataTerritory: [],
      data_head: {},
    };
  },
  watch: {
    
  },
  mounted() {
    console.log("Router: ", this.$router);
    // alert(this.itemRefs.length>1)
    this.getData();
    this.getSupplier();
  },
  methods: {
    leadingZero(value, fixLength) {
      return "0".repeat(fixLength-value.length)+value
    },
    formInputPostingDate() {
      const today = new Date();
      return {
        disabled: false,
        validate: "required",
        name: "date",
        placeholder: "Invoice Date",
        type: "daterange",
        value:{
          startDate: new Date(today.getFullYear(), today.getMonth(), 1),
          endDate: new Date(today.getFullYear(), today.getMonth()+1, 0),
        },
        // min_view:"date",
        format: 'yyyy-MM-dd',
        // type: "multiselect",
        // value: value,
        // option: dtselect,
        multiple: false,
        allowempty: false,
        // track_by: "ID",
        onSelectEvent: (selected) => {
          console.log(selected);
        },
      };
    },
    handleSearch(search){
      this.table.search =search
      this.handleView()
      // this.getData();
    },
    handleChangePage(page) {
      if (this.tab==this.gen){
        this.table.page = page;
        this.handleView()
      }
    },
    handleChangelength(item){
      console.log(item)
      if(item=="All"){
        this.table.end = this.table.total
      }else{
        this.table.end = item
      }
      this.table.length =this.table.end
      this.handleView()
    },
    handlerClick(comp){
      var downloadFile = 10
      if (comp.id_input==downloadFile) {
        const path = comp.href
        const tax_number_id = this.itemRefs[comp.id].tax_number_id
        this.handlerDownload(path,tax_number_id,comp.id)
      }
    },
    handlerDownload(path ="",id,i =0){
      if (path!="") {
        const params = {
          path: path,
          id:id
      };
      this.$vs.loading();
      this.$http
        .get(`api/v1/master/tax-invoice/export/download`, {params})
        .then((resp) => {
          this.$vs.loading.close();
          console.log("resp", resp);
          if (resp.code == 200) {
            // var fileURL = window.URL.createObjectURL(new Blob([resp]));
            var fileLink = document.createElement("a");
            fileLink.target = "_blank"
            fileLink.href = resp.data.file_url;

            // if (file == "excel") {
            // fileLink.setAttribute("download", "Tax-Invoice.csv");
            fileLink.setAttribute("download", "Tax-Invoice.csv");
            // } else {
            // fileLink.setAttribute("download", fileTitle + ".pdf");
            // }
            document.body.appendChild(fileLink);
            fileLink.click();
            // const countExport = 7
            // this.itemRefs[i].inputs[countExport].components.value =""+resp.data.is_downloaded
            // this.handleView();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: err,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log("error boss:", err);
        });
      }else{
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "file doesn't exist",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
      }
    },
    oninput(data, type) {
      console.log(data);
      if (type == "itemref") {
        if (data.name == "checkbox") {
          if (data.head_val != undefined) {
            this.data_head = data;
            if (data.head_val == true) {
              this.itemRefs.forEach((dt, i) => {
                this.itemRefs[i].inputs[1].components.value = true;
              });
            } else if (data.head_val == false) {
              this.itemRefs.forEach((dt, i) => {
                this.itemRefs[i].inputs[1].components.value = false;
              });
            }
          } else {
            if (data.value == false) {
              if (this.data_head) {
                this.data_head.head_val = false;
              }
            }
          }
        }
      }
    },
    updateitemref(data, status) {
      if (status == "add") {
        let i_new = this.itemRefs.length;
        this.itemRefs.push(data);
        for (let i = 0; i < this.itemRefs[i_new].inputs.length; i++) {
          this.itemRefs[i_new].inputs[i].components.id = i_new;
          if (i != 0 && i != 1 && i != 2) {
            this.itemRefs[i_new].inputs[i].components.value = "";
          } else {
            this.itemRefs[i_new].inputs[i].components.value =
              this.itemRefs[i_new - 1].inputs[i].components.value;
          }
        }
      } else if (status == "remove") {
        this.itemRefs = this.itemRefs.filter((v, i) => {
          return i != data;
        });
      }
    },
    getInputs(data = null, i = 0,no=0) {
      var inputs = [];
      var periode = "";
      var invoice_no = "";
      var supplier_code = "";
      var supplier_name = "";
      var tax_number = "";
      var is_creditable = false;
      if (data) {
          periode = data.PostingDate;
          if (periode) {
            periode = moment(periode).format("YYYY-MM-DD");
          }
          invoice_no = data.Code;
          supplier_code = data.SupplierCode;
          supplier_name = data.SupplierName;
          tax_number = data.TaxReturnNumber;
          is_creditable = data.IsCreditable;
      }

      inputs.push({
        components: {
          id: i,
          id_input: 0,
          disabled: true,
          validate: "required",
          name: "no",
          width: 40,
          text_align: "text-center",
          placeholder: "0",
          title: "No",
          type: "text",
          value: "" + no,
        },
      });
      inputs.push({
        components: {
          id: i,
          id_input: 1,
          disabled: false,
          validate: "required",
          name: "checkbox",
          placeholder: "Checkbox",
          title: "checkbox",
          head: "title", //checkbox/title
          type: "checkbox",
          value: false,
        },
      });
      inputs.push({
        components: {
          id: i,
          id_input: 2,
          disabled: true,
          validate: "required",
          name: "tax_invoice_date",
          placeholder: "Tax Invoice Date",
          title: "Tax Invoice Date",
          type: "text",
          value: periode,
        },
      });
      inputs.push({
        components: {
          id: i,
          id_input: 3,
          disabled: false,
          validate: "required",
          name: "invoice_number",
          placeholder: "Invoice No",
          title: "Invoice No",
          type: "text",
          value: invoice_no,
        },
      });
      inputs.push({
        components: {
          id: i,
          id_input: 4,
          disabled: false,
          validate: "required",
          name: "tax_invoice_number",
          placeholder: "Tax Invoice Number",
          title: "Tax Invoice Number",
          type: "text",
          value: tax_number,
        },
      });
      inputs.push({
        components: {
          id: i,
          id_input: 6,
          disabled: true,
          validate: "required",
          name: "supplier_code",
          placeholder: "Supplier Code",
          title: "Supplier Code",
          type: "text",
          value: supplier_code,
        },
      });
      inputs.push({
        components: {
          id: i,
          id_input: 7,
          disabled: true,
          validate: "required",
          name: "supplier_name",
          placeholder: "Supplier Name",
          title: "Supplier Name",
          type: "text",
          value: supplier_name,
        },
      });
      inputs.push({
        components: {
          id: i,
          id_input: 1,
          disabled: false,
          validate: "required",
          name: "is_creditable",
          placeholder: "Is Creditable",
          title: "Is Creditable",
          head: "title", //checkbox/title
          type: "checkbox",
          value: is_creditable,
        },
      });
      
      
      return inputs;
    },
    getInputsHead() {
      var inputs = [];

      inputs.push({
        components: {
          id: 0,
          id_input: 0,
          disabled: true,
          validate: "required",
          name: "no",
          width: 40,
          text_align: "text-center",
          placeholder: "0",
          title: "No",
          type: "input",
          value: "1",
        },
      });
      inputs.push({
        components: {
          id: 0,
          id_input: 1,
          disabled: true,
          validate: "required",
          name: "checkbox",
          placeholder: "Checkbox",
          title: "checkbox",
          head: "checkbox", //checkbox/title
          head_val: false, //for head=checkbox
          type: "checkbox",
          value: false,
        },
      });
      inputs.push({
        components: {
          id: 0,
          id_input: 2,
          disabled: true,
          validate: "required",
          name: "tax_invoice_date",
          placeholder: "Tax Invoice Date",
          title: "Tax Invoice Date",
          type: "input",
          value: "",
        },
      });
      inputs.push({
        components: {
          id: 0,
          id_input: 3,
          disabled: false,
          validate: "required",
          name: "invoice_number",
          placeholder: "Invoice No",
          title: "Invoice No",
          type: "text",
          value: "",
        },
      });
      inputs.push({
        components: {
          id: 0,
          id_input: 4,
          disabled: false,
          validate: "required",
          name: "tax_invoice_number",
          placeholder: "Tax Invoice Number",
          title: "Tax Invoice Number",
          type: "input",
          value: "",
        },
      });
      inputs.push({
        components: {
          id: 0,
          id_input: 6,
          disabled: true,
          validate: "required",
          name: "supplier_code",
          placeholder: "Supplier Code",
          title: "Supplier Code",
          type: "input",
          value: "",
        },
      });
      inputs.push({
        components: {
          id: 0,
          id_input: 7,
          disabled: true,
          validate: "required",
          name: "supplier_name",
          placeholder: "Supplier Name",
          title: "Supplier Name",
          type: "input",
          value: "",
        },
      });
      inputs.push({
        components: {
          id: 0,
          id_input: 1,
          disabled: true,
          validate: "required",
          name: "is_creditable",
          placeholder: "Is Creditable",
          title: "Is Creditable",
          head: "checkbox", //checkbox/title
          head_val: false, //for head=checkbox
          type: "text",
          value: "",
        },
      });
      
      return inputs;
    },
    getIDItemRef() {
      return 0;
    },
    // data-taxallocation
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleView() {
      console.log(this.formSupplier.inputs)
      if (this.DataTerritory[this.formTerritory.inputs.value.ID]) {
        this.$vs.loading();
        const params = {
          length: this.table.length,
          page: this.table.page,
          search: this.table.search,
          order: this.table.order,
          sort: this.table.sort,
          territory_id:
            this.DataTerritory[this.formTerritory.inputs.value.ID].TerrID,
          supplier_ids: this.formSupplier.inputs.value.map(s => s.ID),
          start_date: moment(this.formPostingDate.inputs.value.startDate).format("yyyy-MM-DD"),
          end_date: moment(this.formPostingDate.inputs.value.endDate).format("yyyy-MM-DD"),
        };
        this.$http
          .get(`api/v1/master/tax-invoice/ap-invoice`, { params })
          .then((resp) => {
            if (resp.code == 500) {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
            } else if (resp.code == 200) {
              var dataInvoice = [];
              this.table.total = resp.data.total_record
              this.table.totalPage = resp.data.total_page;
              this.table.totalSearch = resp.data.total_record_search;
              this.table.length = resp.data.total_record_per_page;
              this.setStartEnd()
              var no = this.table.start
              resp.data.dataInvoice.forEach((dt, i) => {
                if (i < 1000) {
                  dataInvoice.push({
                    id: i,
                    id_invoice: dt.ID,
                    tax_number_id:dt.TaxNumberID,
                    action: false,
                    inputs: this.getInputs(dt, i,no),
                  });
                }
                no++
              });
              this.itemRefs = dataInvoice;
              if (this.data_head) {
                this.data_head.head_val = false;
              }
            }
            this.$vs.loading.close();
            console.log("this.itemRefs:",this.itemRefs)
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: err,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            console.log("error boss:", err);
          });
      }
    },
    handlerSearchMS(comp,search){
      if (comp.name =="operating_unit"){
        console.log("search ou:",search)
        this.formOu.inputs.option =this.tempDataOu.filter(v=>{
          var tempText = v.text.toLowerCase()
          var tempSearch = search.toLowerCase()
          return tempText.search(tempSearch)>=0
        })
      }
      console.log("formOu",this.formOu)
    },
    handleExport() {
      this.$vs.loading();
      // var data_id = "";
      var data_id = [];
      // var item = this.itemRefs.filter((dt) => {
      //   return dt.inputs[1].components.value;
      // });

      // item.forEach((dt, i) => {
      this.itemRefs.forEach((dt, i) => {
        if (dt.inputs[1].components.value) {
          data_id.push(dt.id_invoice)
          // data_id += dt.id_invoice;
          // if (i < item.length - 1) {
          //   data_id += ",";
          // }
        }
      });
      console.log(data_id);
      var tax_invoice_type = "";
      if (this.formTaxInvoiceType) {
        tax_invoice_type = this.formTaxInvoiceType.inputs.value.text;
      }
      const params = {
        // params: {
          operating_unit_id: this.DataOperatingUnit[this.formOu.inputs.value.ID]
            ? this.DataOperatingUnit[this.formOu.inputs.value.ID].ID
            : 0,
          territory_id: this.DataTerritory[this.formTerritory.inputs.value.ID]
            ? this.DataTerritory[this.formTerritory.inputs.value.ID].TerrID
            : 0,
          supplier_ids: this.formSupplier.inputs.value.map(s => s.ID),
          tax_invoice_type: tax_invoice_type,
          type_exp: "csv",
          invoice_type: 2,
          tax_type: this.formTaxInvoiceType.inputs.value.ID,
          data_id: data_id,
          is_all: this.tmpitemRef.inputs[1].components.head_val,
          // 7
          data_credits: this.itemRefs.filter(i => i.inputs[1].components.value).map(i => ({id: i.id_invoice, is_creditable: i.inputs[7].components.value}))
        // },
      };
      console.log("params", params)
      this.$http
        .post(`api/v1/master/tax-invoice/export`, params)
        .then((resp) => {
          this.$vs.loading.close();
          console.log("resp", resp);
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.handleView();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: err,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log("error boss:", err);
        });
    },
    handleEdit() {},
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getData() {
      this.$vs.loading();
      const params = {
        // id: this.create.id,
        load_operating_unit: true,
      }
      // console.log(this.formInput)
      this.$http
        .get(`api/v1/master/tax-invoice`, {params})
        .then((resp) => {
          // console.log(this.option.event, 'option')
          this.$vs.loading.close();
          if (resp.code == 500) {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else if (resp.code == 200) {
            this.formInput.inputs.value = resp.data.company;
            this.formInput.inputs.disabled = true;
            console.log(this.formInput);
            var dtou = resp.data.dtOu;
            this.DataOperatingUnit = resp.data.dtOu;
            if (dtou) {
              let dataSelect = [];
              dtou.forEach((dt, i) => {
                dataSelect.push({
                  ID: i,
                  text: dt.Code + " - " + dt.Name,
                });
              });
              this.formOu.inputs.value = dataSelect[0];
              this.getDataTerritory(this.formOu.inputs.value);
              this.tempDataOu = dataSelect
              this.formOu.inputs.option = dataSelect;
            }
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: err,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log("error boss:", err);
        });
    },
    updateforminput(selected, component) {
      if (component.name == "operating_unit") {
        this.getDataTerritory(selected);
      } else if (component.name == "allocation_type") {
        this.automateInputTaxNumber(selected);
      }
    },
    getDataTerritory(selected = null) {
      this.$vs.loading();
      if (selected) {
        const params = {
          id_ou: this.DataOperatingUnit[selected.ID].ID,
        };
        // console.log(this.formInput)
        this.$http
          .get(`api/v1/master/tax-invoice/territory`, { params })
          .then((resp) => {
            console.log("getDataTerritory", resp.data.dataTerr);
            // console.log(this.option.event, 'option')
            this.$vs.loading.close();
            if (resp.code == 500) {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
            } else if (resp.code == 200) {
              var dataSelect = [];
              if (resp.data.dataTerr) {
                this.DataTerritory = resp.data.dataTerr;
                this.DataTerritory.forEach((dt, i) => {
                  dataSelect.push({
                    ID: i,
                    text: dt.Code + " - " + dt.Name,
                  });
                });
              }
              this.formTerritory.inputs.value = dataSelect[0];
              console.log("territory", this.formTerritory.inputs.value)
              this.formTerritory.inputs.option = dataSelect;
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: err,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            console.log("error boss:", err);
          });
      }
    },
    getSupplier() {
      this.$vs.loading();
      this.$http
        .get(`api/v1/master/supplier`)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 500) {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else if (resp.code == 200) {
            // this.formSupplier.inputs.value = {ID: 0, text: "All"};
            this.formSupplier.inputs.option = [{ID: 0, text: "All"}, ...resp.data.map(s => ({ID: s.ID, text: `${s.Code} ${s.Name}`}))];
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: err,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log("error boss:", err);
        });
    },
  },
};
</script>